import { createAction, props } from "@ngrx/store";
import { IStoredProcedure } from "../core/models/stored-procedure.vm";

export const loadStoredProcedures = createAction("[Stored Procedures] Load");
export const loadStoredProceduresSuccess = createAction("[Stored Procedures] Load Success", props<{list: IStoredProcedure[]}>());
export const loadStoredProceduresError = createAction("[Stored Procedures] Load Error");